/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiRequest } from '../models/AiRequest';
import type { AiResponse } from '../models/AiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AiOperationService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Execute AIOperation
     * Executes a single AI operation by calling the backend python engine
     * @param tenantId
     * @param aiClientVersion
     * @param operationId
     * @param versionId
     * @param requestBody
     * @returns AiResponse executeAIOperation 200 response
     * @throws ApiError
     */
    public executeAiOperation(
        tenantId: string,
        aiClientVersion: string,
        operationId: string,
        versionId: string,
        requestBody?: AiRequest,
    ): CancelablePromise<AiResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/tenant/{tenantId}/aiop/{aiClientVersion}/{operationId}/versions/{versionId}',
            path: {
                'tenantId': tenantId,
                'aiClientVersion': aiClientVersion,
                'operationId': operationId,
                'versionId': versionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
